import React from 'react';

const ComponentName = () => {
    return (
        <section className="py-5 bg-light">
            <div className="container">
                <div className="text-center mb-5">
                    
                    <h2 className="mt-3 display-4">Our happy clients 😊</h2>
                </div>

                <div className="row">
                    <div className="col-md-4 mb-4">
                        <div className="card shadow-sm h-100">
                            <div className="card-body">
                                <div className="d-flex mb-3">
                                    {[...Array(5)].map((_, i) => (
                                        <svg
                                            key={i}
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="20"
                                            height="20"
                                            fill="#FDB241"
                                            className="bi bi-star-fill me-1"
                                            viewBox="0 0 16 16"
                                        >
                                            <path d="M3.612 15.443c-.396.198-.86-.149-.746-.592l.83-4.73L.173 6.765c-.329-.32-.158-.888.283-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0l2.184 4.327 4.898.696c.441.062.612.63.283.95l-3.523 3.356.83 4.73c.114.443-.35.79-.746.592L8 13.187l-4.389 2.256z" />
                                        </svg>
                                    ))}
                                </div>
                                <blockquote className="blockquote mb-3">
                                    <p>Integrated Interior transformed my living space beautifully!
                                    They designed my home exactly as I envisioned—stylish, functional, and cozy. Highly recommended!</p>
                                </blockquote>
                                <div className="d-flex align-items-center Testi" >
                                    <img
                                        src="./images/client-1.jpg"
                                        alt=""
                                        className="rounded-circle me-3"
                                     
                                    />
                                    <div>
                                        <p className="mb-0 fw-bold">Capt. Nikhil Singh</p>
                                        <p className="mb-0 text-muted small">House Owner</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-4 mb-4">
                        <div className="card shadow-sm h-100">
                            <div className="card-body">
                                <div className="d-flex mb-3">
                                    {[...Array(5)].map((_, i) => (
                                        <svg
                                            key={i}
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="20"
                                            height="20"
                                            fill="#FDB241"
                                            className="bi bi-star-fill me-1"
                                            viewBox="0 0 16 16"
                                        >
                                            <path d="M3.612 15.443c-.396.198-.86-.149-.746-.592l.83-4.73L.173 6.765c-.329-.32-.158-.888.283-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0l2.184 4.327 4.898.696c.441.062.612.63.283.95l-3.523 3.356.83 4.73c.114.443-.35.79-.746.592L8 13.187l-4.389 2.256z" />
                                        </svg>
                                    ))}
                                </div>
                                <blockquote className="blockquote mb-3">
                                    <p>Our office feels more professional and productive!
                                    Their modern designs and creative layouts have completely elevated our workspace.</p>
                                </blockquote>
                                <div className="d-flex align-items-center Testi">
                                    <img
                                        src="./images/client-3.jpg"
                                        alt=""
                                        className="rounded-circle me-3"
                                       
                                    />
                                    <div>
                                        <p className="mb-0 fw-bold">Deepak kumar </p>
                                        <p className="mb-0 text-muted small">Software engineer</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-4 mb-4">
                        <div className="card shadow-sm h-100">
                            <div className="card-body">
                                <div className="d-flex mb-3">
                                    {[...Array(5)].map((_, i) => (
                                        <svg
                                            key={i}
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="20"
                                            height="20"
                                            fill="#FDB241"
                                            className="bi bi-star-fill me-1"
                                            viewBox="0 0 16 16"
                                        >
                                            <path d="M3.612 15.443c-.396.198-.86-.149-.746-.592l.83-4.73L.173 6.765c-.329-.32-.158-.888.283-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0l2.184 4.327 4.898.696c.441.062.612.63.283.95l-3.523 3.356.83 4.73c.114.443-.35.79-.746.592L8 13.187l-4.389 2.256z" />
                                        </svg>
                                    ))}
                                </div>
                                <blockquote className="blockquote mb-3">
                                    <p>Perfect furniture for our home!
                                    The custom furniture matched our interiors perfectly and was delivered on time.</p>
                                </blockquote>
                                <div className="d-flex align-items-center Testi">
                                    <img
                                        src="./images/client-2.jpg"
                                        alt=""
                                        className="rounded-circle me-3"
                                      
                                    />
                                    <div>
                                        <p className="mb-0 fw-bold">Aarti sharma </p>
                                        <p className="mb-0 text-muted small">Working Professional</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default ComponentName;
